import axios from "axios";

const state = {
  selfHistory: {
    diabetes: 0,
    hypertention: 0,
    cardiac: 0,
    stroke: 0,
    asthma: 0,
    cancer: 0,
    cholesterol: 0,
  },
  familyHistory: {
    diabetes: 0,
    hypertention: 0,
    cardiac: 0,
    stroke: 0,
    asthma: 0,
    cancer: 0,
    cholesterol: 0,
  },
};

const actions = {
  getDiseasesHistory: (context, userId) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "diseases-histories/" + userId,
      })
        .then((response) => {
          const data = response.data.data;
          const self = data.self;
          const family = data.family;
          context.commit("DISEASES_HISTORY_UPDATE", { self, family });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDiseasesHistory: (context, { userId, selfHistory, familyHistory }) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "diseases-histories/",
        data: {
          user_id: userId,
          self_diabetes: selfHistory.diabetes,
          self_hypertention: selfHistory.hypertention,
          self_cardiac: selfHistory.cardiac,
          self_stroke: selfHistory.stroke,
          self_asthma: selfHistory.asthma,
          self_cancer: selfHistory.cancer,
          self_cholesterol: selfHistory.cholesterol,
          family_diabetes: familyHistory.diabetes,
          family_hypertention: familyHistory.hypertention,
          family_cardiac: familyHistory.cardiac,
          family_stroke: familyHistory.stroke,
          family_asthma: familyHistory.asthma,
          family_cancer: familyHistory.cancer,
          family_cholesterol: familyHistory.cholesterol,
        },
      })
        .then((response) => {
          const data = response.data.data;
          const self = data.self;
          const family = data.family;
          context.commit("DISEASES_HISTORY_UPDATE", { self, family });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetDiseasesHistory: (context) => {
    context.commit("DISEASES_HISTORY_RESET");
  },
};

const mutations = {
  DISEASES_HISTORY_UPDATE: (state, { self, family }) => {
    state.selfHistory = self;
    state.familyHistory = family;
  },
  DISEASES_HISTORY_RESET: (state) => {
    state.selfHistory.diabetes = 0;
    state.selfHistory.hypertention = 0;
    state.selfHistory.cardiac = 0;
    state.selfHistory.stroke = 0;
    state.selfHistory.asthma = 0;
    state.selfHistory.cancer = 0;
    state.selfHistory.cholesterol = 0;
    state.familyHistory.diabetes = 0;
    state.familyHistory.hypertention = 0;
    state.familyHistory.cardiac = 0;
    state.familyHistory.stroke = 0;
    state.familyHistory.asthma = 0;
    state.familyHistory.cancer = 0;
    state.familyHistory.cholesterol = 0;
  },
};

const getters = {
  selfHistory: (state) => state.selfHistory,
  familyHistory: (state) => state.familyHistory,
};

export default {
  state: state,
  getters,
  actions,
  mutations,
};
